import Box, { BoxProps } from '@mui/material/Box';
import React from 'react';
import { useShallowMergeSxProps } from '../../../../hooks/useShallowMergeSxProps';
import { SECURED_DISABLED_SX } from '../../constants';
import type { SecuredComponentBaseProps } from '../../types';
import { useSecurity } from '../hooks/useSecurity';

export type SecuredSectionProps = BoxProps & SecuredComponentBaseProps;

export default function SecuredSection({
    securityAction,
    securityTarget,
    securityEnforcementMode = 'hidden',
    fallback = null,
    sx,
    children,
    ...boxProps
}: SecuredSectionProps) {
    const decision = useSecurity(securityAction, securityTarget);
    const disabledSectionSx = useShallowMergeSxProps(SECURED_DISABLED_SX, sx);

    if (!decision.allowed && securityEnforcementMode === 'hidden') {
        return fallback;
    }

    const isDisabled = !decision.allowed || decision.pending;

    if (!isDisabled) {
        return (
            <Box {...boxProps} sx={sx}>
                {children}
            </Box>
        );
    }

    return (
        <Box {...boxProps} aria-disabled={true} sx={disabledSectionSx}>
            {children}
        </Box>
    );
}
